import React, { useEffect, useLayoutEffect } from "react";
import { Outlet } from "react-router-dom";
import { setGlobalLoader } from "../../../redux/slices/globalLoader";
import { useDispatch, useSelector } from "react-redux";
import GlobalLoader from "./globalLoader";
import { setUserType } from "../../../redux/slices/userType";
import { hideMainLoader } from "../../../utils/commonfunction";

const CashierAuthLayout = () => {
    const dispatch = useDispatch();
    const loaderState = useSelector((state) => state.globalLoader);
    useEffect(()=>{
        const body = document.querySelector('body');
        if(body){
            body.classList.remove('restaurant_inner_body');
        }
    },[]);
    useLayoutEffect(() => {
        dispatch(setUserType("admin"));
        Promise.all([
            import("../../../assets/cashier/css/style.css"),
            import("../../../assets/restaurant/css/style.css"),
        ]).then(() => {
            dispatch(setGlobalLoader(false));
            hideMainLoader();
        });
    }, []);

    return (
        <>
            {loaderState ? (
                <GlobalLoader />
            ) : (
                <div className="page">
                    <Outlet />
                </div>
            )}
        </>
    );
};
export default CashierAuthLayout;
